import React from 'react';
import { ActivityExpandedRowLine, ActivityLogLists, TableLogFieldValue } from './';
import { ActivityLogSubList, IActivityLogItem } from '../../../interfaces';
import { Catcher } from '../../Catcher';
import Styles from '../../styles/m_viewStyles.less';

export function ActivityLogUpdateInfo({ log }: { log: IActivityLogItem }) {
    const { meta, entity } = log;
    return (
        <Catcher>
            <div className={Styles.expandedRow}>
                <ActivityExpandedRowLine title={`${entity} Id`}>
                    <TableLogFieldValue entity={entity} value={log.logableId} prop={'id'} />
                </ActivityExpandedRowLine>
                {Object.entries(meta).map(([metaKey, metaValue]) => {
                    if (metaKey === ActivityLogSubList.LISTS) {
                        return <ActivityLogLists key={metaKey} lists={metaValue} />;
                    } else if (Array.isArray(metaValue)) {
                        return (
                            <ActivityExpandedRowLine title={metaKey} key={metaKey}>
                                &quot;
                                <TableLogFieldValue value={metaValue?.[0]} prop={metaKey} entity={log.entity} />
                                &quot; ---&gt; &quot;
                                <TableLogFieldValue value={metaValue?.[1]} prop={metaKey} entity={log.entity} />
                                &quot;
                            </ActivityExpandedRowLine>
                        );
                    }

                    return (
                        <ActivityExpandedRowLine title={metaKey} key={metaKey}>
                            <TableLogFieldValue value={metaValue} prop={metaKey} entity={log.entity} />
                        </ActivityExpandedRowLine>
                    );
                })}
            </div>
        </Catcher>
    );
}
